<template>
  <div>
    <div class="mb-4 text-subtitle-2">
      <span class="secondary-font font-weight-bold">{{
        $t("subscriptions.title")
      }}</span>
    </div>
    <v-card class="elevation-0" color="rgba(255,255,255,0)">
      <v-card-actions class="px-0 mb-2">
        <v-btn depressed @click="refreshItems()" :disabled="loading.filter" color="grey lighten-2" :loading="loading.refresh">
          <v-icon left>mdi-refresh</v-icon>
          {{ $t("btn.refresh") }}
        </v-btn>
        <v-btn @click="getFilter()" depressed :loading="loading.filter" color="grey lighten-2" class="mr-2">
          <v-icon left>mdi-filter-variant</v-icon>
          {{ $t('btn.filter') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="elevation-1">
      <v-card-title>
        <span class="text-body-1">
          <span class="secondary-font font-weight-bold">{{
            $t("subscriptions.list.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="meta.total"
        :loading="loading.list"
        :items-per-page="itemPerPage"
        :options.sync="pagination"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :footer-props="footerProps"
      >
        <template v-slot:body="{ items }" v-if="!_.isEmpty(items)">
          <tbody>
            <template v-for="item in items">
              <v-hover :key="item.id" v-slot:default="{ hover }">
                <tr>
                  <td style="min-width: 160px">
                    {{ $moment(item.created).format("YYYY-MM-DD HH:mm:ss") }}
                  </td>
                  <td v-if="$auth.check(['ROLE_ADMIN'])">
                    {{ item.application.user.username }}
                  </td>
                  <td style="min-width: 120px">
                    <v-chip
                      class="table-chips text-body-2"
                      color="grey lighten-4"
                    >
                      <span>{{ item.account_number }}</span>
                    </v-chip>
                  </td>
                  <td>{{ item.amount }}</td>
                  <td>
                    <v-chip
                      class="table-chips text-body-2"
                      color="success"
                      v-if="item.status === 'SUCCESS'"
                    >
                      <span>{{
                        $t(`subscriptions.fields.status.${item.status}`)
                      }}</span>
                    </v-chip>
                    <v-chip
                      class="table-chips text-body-2"
                      color="primary"
                      v-else-if="item.status === 'PENDING' || subscription.status === 'IN_PROGRESS'"
                    >
                      <span>{{
                        $t(`subscriptions.fields.status.${item.status}`)
                      }}</span>
                    </v-chip>
                    <v-chip
                      class="table-chips text-body-2"
                      color="error"
                      v-else
                    >
                      <span>{{
                        $t(`subscriptions.fields.status.${item.status}`)
                      }}</span>
                    </v-chip>
                  </td>
                  <td>
                    <v-chip
                      class="table-chips text-body-2"
                      color="grey lighten-4"
                    >
                      <span>{{
                        $t(`cga.fields.subscription_type.${item.type}`)
                      }}</span>
                    </v-chip>
                  </td>
                  <td>{{ $objectPath.get(item, "pack.label") }}</td>
                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="getDetails(item)"
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          v-show="hover || $vuetify.breakpoint.mdAndDown"
                        >
                          <v-icon color="primary">mdi-eye-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("btn.details") }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </v-hover>
            </template>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    <subscription-details
      :subscription="subscription"
      :dialog="dialog.details"
    ></subscription-details>
    <subscription-filter @filter="applyFilter" :dialog="dialog.filter"></subscription-filter>
  </div>
</template>

<script>
import SubscriptionDetails from "./details";
import SubscriptionFilter from './filter';
import ListMixin from "./../../mixins/commons/list";

export default {
  mixins: [ListMixin],
  data: () => ({
    url_items: "/api/subscriptions",
    dialog: {
      details: {
        display: false,
      },
      filter: {
        display: false
      }
    },
    subscription: {},
  }),
  methods: {
    setHeaders() {
      const headers = [
        {
          text: this.$t("commons.fields.created.title"),
          align: "start",
          sortable: true,
          value: "created",
          width: 160,
        },
      ];
      if (this.$auth.check(["ROLE_ADMIN"])) {
        headers.push({
          text: this.$t("commons.fields.account.title"),
          align: "start",
          sortable: false,
          value: "application.user.username",
          width: 90,
        });
      }
      this.headers = [
        ...headers,
        {
          text: this.$t("subscriber.fields.account_number.title"),
          align: "start",
          sortable: false,
          value: "amount",
          width: 120,
        },
        {
          text: this.$t("subscriptions.fields.amount.title"),
          align: "start",
          sortable: false,
          value: "amount",
          width: 80,
        },
        {
          text: this.$t("subscriptions.fields.status.title"),
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
        },
        {
          text: this.$t("cga.fields.subscription_type.title"),
          align: "start",
          sortable: false,
          value: "type",
          width: 80,
        },
        {
          text: this.$t("cga.fields.pack.title2"),
          align: "start",
          sortable: false,
          value: "pack.label",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: null,
          width: 60,
        },
      ];
    },
    getDetails(subscription) {
      this.subscription = subscription;
      this.dialog.details.display = true;
    },
    getFilter() {
      this.dialog.filter.display = true;
    }
  },
  components: {
    SubscriptionDetails,
    SubscriptionFilter
  },
};
</script>